// @flow
import React from 'react';
import {connect} from 'react-redux';
import ArenaCombatantScoreboard from './ArenaCombatantScoreboard'
import {modelsFromObject} from '../../helpers/models-from-object.js'
import ArenaCombatantWaitingBlip from './ArenaCombatantWaitingBlip'
import Skins from '../../_data/Skins.js'
import {isSubmissionMenuOpen} from './is-submission-menu-open.js'
import ArenaCombatantLaptop from './ArenaCombatantLaptop'
import {setCombatantValue} from '../../redux-actions/battle-actions.js'
import audioManager from '../../_audio/audio-manager.js'
// import {getCombatantArenaPosition} from './getCombatantArenaPosition'
import CombatantWarningIcon from '../svg-getters/CombatantWarningIcon'
import CombatantShadow from '../svg-getters/CombatantShadow'
import CombatantTargetMarker from '../svg-getters/CombatantTargetMarker'

const skins = Skins(); //cache all skin models right here.

class ArenaCombatant extends React.Component {

  componentDidMount() {
    this.writeDomPositionToCombatantModel();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.isPlayerControlled) {
      if (
        !this.props.isCurrentlySelecting &&
        newProps.isCurrentlySelecting
      ) {
        //hop!
        audioManager.playSfx("sfx_jump");
        setCombatantValue(this.props.model.id, {
          animationCssRule: "jump 0.2s"
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    //Write X/Y coord data to combatant
    if (
      this.props.vW !== prevProps.vW ||
      this.props.vH !== prevProps.vH
    ) {
      this.writeDomPositionToCombatantModel();
    }
  }

  //This provides our X/Y in state so external components can overlay on our exact position
  writeDomPositionToCombatantModel() {
    const bodyRect = document.getElementsByClassName("ArenaView")[0].getBoundingClientRect();
    const boundingRect = this.refs.combatant.getBoundingClientRect();

    setCombatantValue(this.props.model.id, {
      boundingClientRect: {
        top: String(boundingRect.top - bodyRect.top) + "px",
        left: String(boundingRect.left - bodyRect.left) + "px",
        width: String(boundingRect.width) + "px",
        height: String(boundingRect.height) + "px",
      }
    })
  }

  handleClick(e) {
    //This will either show the info view or target this person as the combatant
    if (this.props.isTargetable) {

      //Set this one as the active one
      // (Note: this is technically optional, but I like the clean notion that the Submitted one is always selected?)
      this.props.arenaMenuSnapshot.setActive(this.props.myMenuNode);

      //aaaand submit my menu node
      this.props.arenaMenuSnapshot.submit(this.props.myMenuNode);
    }

    // console.log('combatant clicked! info view!');
  }

  handleHover() {
    if (this.props.myMenuNode) {
      this.props.arenaMenuSnapshot.setActive(this.props.myMenuNode);
    }
  }

  /** This combatant is controlled by a different human player Online and we're waiting for them to choose  */
  isWaitingForThisCombatantToSubmit() {
    return this.props.isCurrentlySelecting && !this.props.isPlayerControlled
  }


  getTurnBubbleArray() {
    /* Look at the seriesTurnOrder to know how many bubbles you should have. */
    /* Compare that to the turns that have been used. */
    const {model, seriesTurnOrder, seriesTurnsSubmitters} = this.props;

    //Don't show these if Combatant is dead
    if (!model.isAlive()) {
      return [];
    }

    return seriesTurnOrder.filter(combId => {
      return combId === model.id || combId === `deadline::${model.id}`
    }).map(combId => {
      return !seriesTurnsSubmitters.includes(combId) //True = full bubble.
    });
    //EX: return [true, false] for 1 full bubble, then 1 empty bubble
  }

  hasTargetingWarning() {
    //Look for validity problems with me
    if (this.props.arenaSubmissionMenuAction && this.props.isTargetable) {
      const validityModel = this.props.arenaSubmissionMenuAction.getValidity(
        this.props.arenaSubmissionMenuAction,
        {}, //casterModel, not really needed.
        [this.props.model]
      );
      //Return true if the validityModel is invalid
      return !validityModel.isValid
    }
    return false
  }

  /** Show a bot flag if this person is a BOT in multiplayer mode */
  renderBotIcon() {
    if (
        this.props.isMultiplayerMode &&
        this.props.model.isBot
    ) {
      const style = {
        position: "absolute",
        fontSize: "0.5em",
        color: "#647365",
        background: "#D9EEDA",
        padding: "0.25em 0.5em",
        border: "0.2em solid #EAFFEB",
        left: "50%",
        transform: "translateX(-50%)",
        top: "70%",
        zIndex: 4
      };
      return (
        <div style={style}>BOT</div>
      )
    }
    return null;
  }


  renderTargetingCrosshair(characterSize) {

    if (!this.props.isTargetable) {
      return null
    }

    //Create a crosshair flag for this option attacking multiple opponents at the same time.
    const isTargetingMultipleCombatants = (
      this.props.arenaMenuSnapshot.viewId === "targetsView" &&
      this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.targetIds &&
      this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.targetIds.length > 1
    );

    //Decide if we should show this on mobile or not
    const shouldShowCrosshairOnMobile = this.props.isTouchMode ? isTargetingMultipleCombatants : false;

    //If I'm targetable and selected, show the crosshair
    if (this.props.isSelected && (shouldShowCrosshairOnMobile || !this.props.isTouchMode)) {

      const imageSrc = this.props.isEnemyTeam
        ? "/images/misc/targeting.svg"
        : "/images/misc/targeting-friendly.svg";

      const style = {
        position: "absolute",
        left: 0, right: 0, top: 0, bottom: 0,
        //background: "red",
        background: `url(${imageSrc}) no-repeat no-repeat`,
        backgroundSize: "cover",
        backgroundPosition: "0% 0%",
        zIndex: 4,
        animation: "targetCrosshair 0.2s infinite alternate-reverse steps(3)"
      };

      return (
        <div style={style}/>
      )
    }

      //Default to static marker (if we're targeted)
      const style = {
        position: "absolute",
        left: 0, top: "-6%",
        zIndex: 4,
      };
      return CombatantTargetMarker(characterSize, style, {isFriendly: !this.props.isEnemyTeam})
  }

  getLeftPosition() {

    const pd = this.props.positionData;
    const vW = this.props.vW;

    //Mobile layout!
    if (this.props.viewportMode === "portrait") {
      if (pd.totalPositions === 3) { //THREE people on the team
        if (pd.position === 2) {
          return "20%"
          //return vW * 4
        }
        if (pd.position === 1) {
          return "50%"
          //return vW * 34
        }
        if (pd.position === 3) {
          return "80%"
          //return vW * 62
        }
      }
      if (pd.totalPositions === 2) { //TWO people on the team
        if (pd.position === 1) {
          return 30
        }
        if (pd.position === 2) {
          return vW * 48
        }
      }
      //Assume middle
      return vW * 32 //ONE person on the team
    }

    //Desktop layout!
    if (this.props.viewportMode === "landscape") {
      if (pd.totalPositions === 3) { //THREE people on the team
        if (pd.position === 2) {
          return vW * 15
        }
        if (pd.position === 1) {
          return vW * 30
        }
        if (pd.position === 3) {
          return vW * 45
        }
      }
      if (pd.totalPositions === 2) { //TWO people on the team
        if (pd.position === 1) {
          return vW * 20
        }
        if (pd.position === 2) {
          return vW * 43
        }
      }
      //Assume middle
      return vW * 30 //ONE people on the team
    }



  }

  getTopPosition() {
    const pd = this.props.positionData;
    const vW = this.props.vW;
    const vH = this.props.vH;

    //Possibly move combatants pretty far up if
    //a) Friendly team, b) Submission Menu is open, and c) we're on mobile
    if (!this.props.isEnemyTeam && isSubmissionMenuOpen() && this.props.viewportMode === "portrait") {

      //The selector is a little bit higher
      if ( //WARNING! This logic copied from below
        this.props.isCurrentlySelecting && //I'm selecting
        this.props.isPlayerControlled && //I'm controlled by the player
        !this.props.arenaSubmissionIsSubmitted //The action has not been submitted yet
      ) {
        return vH * -11
      }

      //Everybody else
      return vH * -8;
    }


    if (pd.totalPositions === 3 && pd.position === 1) { //1 is set to be the middle (the main)

      //MOBILE vertical offset for middle person
      if (this.props.viewportMode === "portrait") {
        return (this.props.isEnemyTeam) ? vH * -3 : vH * 3;
      }

      //DESKTOP vertical offset for middle person
      if (this.props.viewportMode === "landscape") {
        return (this.props.isEnemyTeam) ? vW * -4 : vW * 4;
      }
    }
    return 0
  }

  //If this is an enemy combatant who is currently selecting, nudge them forward a little bit.
  //This value is animated by transform
  getSelectingYAxisAdjustment(initialYPosition) {
    const vH = this.props.vH;

    if (this.props.isEnemyTeam && this.props.isCurrentlySelecting) {
      return initialYPosition + (vH * 3)
    }

    return initialYPosition
  }

  getZIndex() {
    const pd = this.props.positionData;

    if (this.props.isEnemyTeam) {
      //Enemy Team: Middle person has lowest Z Index
      if (pd.totalPositions === 3 && pd.position === 2) {
        return 1;
      }
      return 2;

    } else {
      //Ally Team: Middle person has highest Z Index
      if (pd.totalPositions === 3 && pd.position === 2) {
        return 2;
      }
      return 1;
    }
  }

  getSkinSrc() {
    const skinModel = skins[this.props.model.skinId];
    if (this.props.isEnemyTeam) {
      return skinModel.frontViewSrc;
    }

    //Turn to face the user if currently selecting
    if (
      this.props.isCurrentlySelecting && //I'm selecting
      this.props.isPlayerControlled && //I'm controlled by the player
      !this.props.arenaSubmissionIsSubmitted //The action has not been submitted yet
    ) {
      return skinModel.frontViewSrc
    }

    return skinModel.backViewSrc;
  }


  render() {

    const {viewportMode, model, isEnemyTeam} = this.props;

    let vW = (viewportMode === "landscape")
      ? (this.props.vW / 3) //Desktop variant of vW
      : this.props.vW;

    const topPosition = this.getSelectingYAxisAdjustment(
      this.getTopPosition()
    );

    const style = {
      position: "absolute",
      // border: this.getBorderStyle(),
      left: this.getLeftPosition(),
      //transform: "translateX(-50%)",
      transform: `translate3d(-50%, ${topPosition}px, 0)`,

      // top: this.getTopPosition(),
      //transition: "top 0.3s ease-in",
      transition: "transform 0.3s ease-in",
      zIndex: this.getZIndex(),

      // //Note: this will be revisited when doing Desktop and need keyboarding selected states
      // background: this.props.isTargetable && this.props.isSelected && !this.props.isTouchMode ? "rgba(255,0,0,0.3)" : "initial",
    };



    const characterStyle = {
      position: "absolute", left:0, top:0,
      animation: model.animationCssRule,
      width: "100%",
    };

    const shadowColor = (this.props.isTargetable)
      ? (this.props.isEnemyTeam ? "#e93434" : "#8cb9ef") //red, blue
      : null;

    const shadowStyle = {
      position: "absolute", left:0, top:0,
      width: "100%",
      transition: "fill 0.2s",
      fill: shadowColor, //red or nothing
      opacity: this.props.isTargetable ? "0.8" : null //SVG will default if falsy value
    };


    const characterSize = "5.5em"; //vW * 29; //This number sets the character size
    const characterContainerStyle = {
      width: characterSize,
      height: characterSize,
      position:"relative",
      WebkitTapHighlightColor: `rgba(0, 0, 0, 0)`
    };


    return (
      <div style={style}>
        <div style={characterContainerStyle}
          onClick={this.handleClick.bind(this)}
          onMouseEnter={this.handleHover.bind(this)}
          ref="combatant">
            {CombatantShadow(characterSize, shadowStyle)}
            <img style={characterStyle} src={this.getSkinSrc()} alt={model.name} />
            <ArenaCombatantLaptop view={isEnemyTeam ? "back" : "front"} />
            { this.renderBotIcon(characterSize) }
            { this.renderTargetingCrosshair(characterSize) }
            {
              this.hasTargetingWarning()
                ? CombatantWarningIcon(characterSize, {
                  ...characterContainerStyle,
                  zIndex: 3
                })
                : null
            }
        </div>
        <ArenaCombatantScoreboard
            vW={vW}
            name={model.name}
            hp={model.hp}
            maxHp={model.maxHp}
            pp={model.pp}
            maxPp={model.maxPp}
            status={model.status}
            isEnemyTeam={isEnemyTeam}
            turnBubbles={ this.getTurnBubbleArray() }

        />
        <ArenaCombatantWaitingBlip
          vW={vW}
          isActive={this.isWaitingForThisCombatantToSubmit()}
        />
      </div>
    )
  }
}

//Look through all targetable Ids and check for mine (indicates that I can be cursored to)
function getIsTargetable(snapshot, combatantId) {
  if (snapshot.viewId === "targetsView") {
    const optionsMatchingMyId = modelsFromObject(snapshot.optionsData).filter(option => {
      const targetIds = option.viewBag.targetIds || [];
      return targetIds.includes(combatantId);
    });
    return (optionsMatchingMyId.length > 0)
  }
  return false;
}

//Check if my combatant ID is listed in the targetIds of the current selection
//(indicates that I am already cursored)
function getIsSelected(snapshot, combatantId) {
  if (
    !snapshot.currentlySelectedOptionData ||
    !snapshot.currentlySelectedOptionData.viewBag.targetIds) {
    return false
  }
  return snapshot.currentlySelectedOptionData.viewBag.targetIds.includes(combatantId);
}

//Look up my menu option node from the menu model
function getMyMenuNode(snapshot, combatantId) {
  if (snapshot.viewId === "targetsView") {
    return modelsFromObject(snapshot.optionsData).find(option => {
        const targetIds = option.viewBag.targetIds || [];
        return targetIds.includes(combatantId);
      }) || null;
  }
  return null;
}





export default connect((state, props) => {

  return {
    vW: state.global.vW,
    vH: state.global.vH,

    viewportMode: state.global.viewportMode,

    arenaMenuSnapshot: state.battle.arenaMenuSnapshot,
    arenaSubmissionMenuAction: state.battle.arenaSubmissionMenuAction,

    isSelected: getIsSelected(state.battle.arenaMenuSnapshot, props.model.id),
    isTargetable: getIsTargetable(state.battle.arenaMenuSnapshot, props.model.id),
    myMenuNode: getMyMenuNode(state.battle.arenaMenuSnapshot, props.model.id),

    //For keyboard vs touch variations on UI
    isTouchMode: state.global.isTouchMode,

    isMultiplayerMode: state.battle.isMultiplayerMode,

    //For "waiting" badge
    isCurrentlySelecting: state.battle.combatantSelectingAction === props.model.id || state.battle.combatantSelectingAction === (`deadline::${props.model.id}`),
    isPlayerControlled: state.battle.battlePlayerId.includes(props.model.id),

    //Know when I'm done submitting.
    arenaSubmissionIsSubmitted: state.battle.arenaSubmissionIsSubmitted,

    //Know who still has left to go.
    seriesTurnOrder: state.battle.seriesTurnOrder,
    seriesTurnsSubmitters: state.battle.seriesTurnsSubmitters,

  }
})(ArenaCombatant)


// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaCombatant.js